export const slideMenu = () => {
    const navigation = document.querySelector('.header__nav');

    if (!navigation) return;

    // Only select first-level submenu toggles
    const dropdownToggles = navigation.querySelectorAll(':scope > ul > .menu-item-has-children > .submenu-toggle');

    const originalMenu = navigation.querySelector(':scope > ul');
    
    // Add classes to original menu for animations
    originalMenu.classList.add('menu-panel', 'slide-in');

    // Stack to remember panel history (including original menu)
    const panelStack = [originalMenu];
    let isProcessing = false; // Prevent multiple clicks

    // Helper to close all panels
    const closeAllPanels = () => {
        const allPanels = navigation.querySelectorAll('.slide-menu-panel');
        allPanels.forEach(panel => {
            if (panel._focusTrapHandler) {
                panel.removeEventListener('keydown', panel._focusTrapHandler);
            }
            panel.remove();
        });
        
        // Reset original menu to slide-in position
        originalMenu.classList.remove('slide-out-left');
        originalMenu.classList.add('slide-in');
        panelStack.length = 1; // Keep original menu in stack
        panelStack[0] = originalMenu;
    };

    // Helper to get focusable elements
    const getFocusableElements = (container) => {
        return container.querySelectorAll(
            'a[href], button, input, textarea, select, details, [tabindex]:not([tabindex="-1"])'
        );
    };

    // Helper to trap focus within a container
    const trapFocus = (container) => {
        const focusableElements = getFocusableElements(container);
        const firstFocusable = focusableElements[0];
        const lastFocusable = focusableElements[focusableElements.length - 1];

        // Remove any existing focus trap listeners
        container.removeEventListener('keydown', container._focusTrapHandler);

        container._focusTrapHandler = (e) => {
            if (e.key === 'Tab') {
                if (e.shiftKey) {
                    // Shift + Tab
                    if (document.activeElement === firstFocusable) {
                        e.preventDefault();
                        // Close all panels when trying to tab backwards from first element
                        closeAllPanels();
                        return;
                    }
                } else {
                    // Tab
                    if (document.activeElement === lastFocusable) {
                        e.preventDefault();
                        // Close all panels when trying to tab forwards from last element
                        closeAllPanels();
                        return;
                    }
                }
            }
            // Handle Escape key to go back
            if (e.key === 'Escape') {
                e.preventDefault();
                const globalBackBtn = document.querySelector('.slide-menu-back');
                if (globalBackBtn) {
                    globalBackBtn.click();
                }
            }
        };

        container.addEventListener('keydown', container._focusTrapHandler);
        
        // Focus the first <a> element instead of any focusable element
        const firstLink = container.querySelector('a');
        if (firstLink) {
            firstLink.focus();
        } else if (firstFocusable) {
            firstFocusable.focus();
        }
    };

    // Global focus listener to detect when focus leaves the slide panels
    document.addEventListener('focusin', (e) => {
        const activePanel = navigation.querySelector('.slide-in');
        if (activePanel && !activePanel.contains(e.target)) {
            // Focus moved outside the active panel, close all panels
            closeAllPanels();
        }
    });

    // Helper to create slide panel for a given menu item
    const createSlidePanel = (menuItem) => {
        // Get current active panel
        const currentPanel = panelStack[panelStack.length - 1];
        
        // Slide current panel to the left
        if (currentPanel) {
            currentPanel.classList.remove('slide-in');
            currentPanel.classList.add('slide-out-left');
            // Remove focus trap from previous panel
            if (currentPanel._focusTrapHandler) {
                currentPanel.removeEventListener('keydown', currentPanel._focusTrapHandler);
            }
        }

        // Create slide container
        const slideDiv = document.createElement('ul');
        slideDiv.classList.add('slide-menu-panel', 'menu-panel');

        // Add level-specific classes based on panel stack depth
        const panelLevel = panelStack.length; // Current level (1 = original, 2 = first submenu, etc.)
        slideDiv.classList.add(`menu-panel__level-${panelLevel}`);
        
        slideDiv.setAttribute('role', 'dialog');
        slideDiv.setAttribute('aria-label', `${menuItem.querySelector('a').textContent} submenu`);

        // Back button
        const backBtn = document.createElement('div');
        backBtn.innerHTML = `<button class="slide-menu-back">${bnlabels?.back || 'Back'}</button>`;
        backBtn.classList.add('slide-menu-back-item');
        slideDiv.appendChild(backBtn);

        const navSearch = navigation.querySelector('.header__nav-search');
        if (navSearch) {
            const navSearchClone = navSearch.cloneNode(true);
            navSearchClone.classList.add('slide-menu-nav-search');
            backBtn.appendChild(navSearchClone);
        }

        // Current menu item title
        const titleItem = document.createElement('li');
        const title = document.createElement('a');
        titleItem.classList.add('slide-menu-title');
        title.textContent = menuItem.querySelector('a').textContent;
        title.href = menuItem.querySelector('a').href || '#';
        title.target = menuItem.querySelector('a').target || '_self';
        title.classList.add('slide-menu-title-item');
        titleItem.appendChild(title);
        slideDiv.appendChild(titleItem);

        // First-level children
        const childrenList = menuItem.querySelector('ul');
        if (childrenList) {
            const cloneList = childrenList.cloneNode(true);
            // Append all children to the slide panel
            Array.from(cloneList.children).forEach(child => {
                child.classList.add('slide-menu-subitem');
                slideDiv.appendChild(child);
            });
        }

        const hasButtonElement = originalMenu.querySelector('li.has-button');
        if (hasButtonElement) {
            const hasButtonClone = hasButtonElement.cloneNode(true);
            hasButtonClone.classList.add('slide-menu-button-item');
            slideDiv.appendChild(hasButtonClone);
        }


        // Add to stack before appending to DOM
        panelStack.push(slideDiv);
        navigation.appendChild(slideDiv);

        // Start from right position, then animate in
        slideDiv.style.transform = 'translateX(100%)';
        slideDiv.offsetHeight; // Force reflow

        // Trigger slide-in
        requestAnimationFrame(() => {
            slideDiv.classList.add('slide-in');
            slideDiv.style.transform = '';
            
            // Set up focus trap after animation starts
            setTimeout(() => {
                trapFocus(slideDiv);
            }, 50);
        });

        // Back button functionality
        const backButton = backBtn.querySelector('.slide-menu-back');
        backButton.addEventListener('click', handleBackClick);
    };

    // Back button handler
    const handleBackClick = (e) => {
        if (isProcessing) return;
        isProcessing = true;
        
        e.preventDefault();
        e.stopPropagation();
        
        const currentPanel = panelStack[panelStack.length - 1];
        
        // Remove focus trap from current panel
        if (currentPanel && currentPanel._focusTrapHandler) {
            currentPanel.removeEventListener('keydown', currentPanel._focusTrapHandler);
        }
        
        // If we're at the original menu, do nothing (or close all if desired)
        if (panelStack.length <= 1) {
            isProcessing = false;
            return;
        }
        
        // Remove current panel from stack
        panelStack.pop();
        const prevPanel = panelStack[panelStack.length - 1];
        
        // Animate current panel out
        currentPanel.classList.remove('slide-in');
        currentPanel.classList.add('slide-out-right');
        
        // Animate previous panel in
        if (prevPanel) {
            prevPanel.classList.remove('slide-out-left');
            prevPanel.classList.add('slide-in');
            
            // Only re-establish focus trap if it's not the original menu
            if (prevPanel !== originalMenu) {
                setTimeout(() => {
                    trapFocus(prevPanel);
                }, 100);
            }
        }
        
        // Remove current panel after animation
        if (currentPanel !== originalMenu) {
            currentPanel.addEventListener('transitionend', () => {
                setTimeout(() => {
                    currentPanel.remove();
                    isProcessing = false;
                }, 300);
            }, { once: true });
        } else {
            isProcessing = false;
        }
    };

    // Use event delegation for child submenu toggles
    navigation.addEventListener('click', (e) => {
        if (isProcessing) return;
        
        // Check if clicked element is a submenu toggle inside a slide panel
        const slidePanel = e.target.closest('.menu-panel');
        const submenuToggle = e.target.closest('.submenu-toggle');
        
        if (slidePanel && submenuToggle) {
            const menuItemWithChildren = submenuToggle.closest('.menu-item-has-children');
            if (menuItemWithChildren) {
                isProcessing = true;
                e.preventDefault();
                e.stopPropagation();
                
                createSlidePanel(menuItemWithChildren);
                
                setTimeout(() => { isProcessing = false; }, 300); // Reset after animation
            }
        }
    });

    dropdownToggles.forEach(toggle => {
        toggle.addEventListener('click', (e) => {
            if (isProcessing) return;
            isProcessing = true;
            
            e.preventDefault();
            
            // Get the parent menu item
            const menuItem = toggle.closest('.menu-item-has-children');
            createSlidePanel(menuItem);
            
            setTimeout(() => { isProcessing = false; }, 300); // Reset after animation
        });
    });
};